<app-titledescription
  [title]="'Materias'"
  [description]="'Aca se muestra el listado de materias'"
></app-titledescription>
<app-button
  text="Agregar Materias"
  tooltip="Agregar nueva materia"
  href="/materias/create"
></app-button>
<div style="margin-bottom: 20px"></div>
<ng-template #table>
  <!-- @if (dataSelectNiveles.length > 0 && dataSelectModalidades.length > 0) { -->
    <div style="display: flex; gap: 1em; margin-bottom: 1em">
      <!-- <app-select
        [label]="'Seleccione Nivel'"
        [data]="dataSelectNiveles"
        [(ngModel)]="nivelSelected"
        (selectValue)="selectValueNivel($event)"
      ></app-select>
      <app-select
        [label]="'Seleccione Modalidad'"
        [data]="dataSelectModalidades"
        [(ngModel)]="modalidadSelected"
        (selectValue)="selectValueModalidad($event)"
      ></app-select> -->
      <app-autocomplete-field
          [label]="'Seleccione Nivel'"
          [placeholder]="'Escribe para buscar...'"
          [options]="dataSelectNiveles"
          (optionSelected)="selectValueNivel($event)">
        </app-autocomplete-field>
      <app-autocomplete-field
          [label]="'Seleccione Modalidad'"
          [placeholder]="'Escribe para buscar...'"
          [options]="dataSelectModalidades"
          (optionSelected)="selectValueModalidad($event)">
        </app-autocomplete-field>
    </div>
    @if(dataFetch){
      <app-table
        [columnsNames]="columnNames"
        [dataFetch]="dataFetch"
        [totalItems]="totalItems"
        (fetchAgain)="fetchMateriasByNivelModalidad($event.options, $event.ignoreCache)"
        [labelFilter]="'Descripcion'"
        [filterable]="true"
        [actions]="actions"
        [apiService]="apiService"
        (returnActionEvent)="delete($event)"
        (callCustomFunction)="openModal($event)"
        [templateRef]="templateAction"
        [paginateOptions]="paginateOptions"
        [pageIndex]="pageIndex"
      ></app-table>
    }
  <!-- } -->
</ng-template>

<ng-template #templateAction>
  @if (templateDelete) {
    <h2 class="text-xl font-bold mb-1">Eliminar</h2>
    <p class="text-lg text-gray-600 mb-4">Se eliminará la materia del título seleccionadoss</p>
    <mat-form-field appearance="fill" style="width: 100%; margin-top: 1em">
      <mat-label>Titulo</mat-label>
      <mat-select [(ngModel)]="titulo_id" required>
        <mat-option *ngFor="let titulo of titulos; trackBy: trackByTitulo" [value]="titulo.value">{{
          titulo.label
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%; margin-top: 1em">
      <mat-label>Motivo</mat-label>
      <mat-select [(ngModel)]="motivo">
        <mat-option *ngFor="let option of motivosBaja" [value]="option.value">{{
          option.label
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%; margin-top: 1em">
      <mat-label>Comentario (opcional)</mat-label>
      <textarea
        matInput
        [(ngModel)]="comment"
        rows="3"
        placeholder="Ingrese un comentario"
      ></textarea>
    </mat-form-field>
  } @else if(!isLoading){
    <!-- @if(isLoading){
      <p>Cargando títulos vinculados...</p>
    } else { -->
    <h2 class="text-xl font-bold mb-2">Títulos vinculados a la materia</h2>
    <ul class="text-md mb-2">
      <li><strong>Nombre:</strong> {{ materiaName }}</li>
      <li><strong>Código:</strong> {{ materia_id }}</li>
    </ul>
    <table class="min-w-full border text-sm mb-4">
      <thead>
        <tr class="bg-gray-100">
          <th class="border px-2 py-1 text-left">Código</th>
          <th class="border px-2 py-1 text-left">Descripción</th>
          <th class="border px-2 py-1 text-left">Estado</th>
          <th class="border px-2 py-1 text-left">Observación</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let titulo of titulos; trackBy: trackByTitulo"
          [class.row-deleted]="titulo.deleted_at"
        >
          <td class="border px-2 py-1">{{ titulo.value }}</td>
          <td class="border px-2 py-1">{{ titulo.label }}</td>
          <td class="border px-2 py-1">{{ titulo.deleted_at ? 'Eliminado' : 'Activo' }}</td>
          <td class="border px-2 py-1">{{ titulo.observacion }}</td>
        </tr>
        <tr *ngIf="!titulos || titulos.length === 0">
          <td class="border px-2 py-1 text-center" colspan="2">No hay títulos vinculados</td>
        </tr>
      </tbody>
    </table>
    <!-- } -->

  }@else {
    <div class="spinner-general" style="display: flex; justify-content: center; align-items: center; min-height: 120px;">
      <mat-spinner></mat-spinner>
    </div>
  }
</ng-template>
<app-card [templateRefContent]="table"></app-card>
